import React from 'react';
import { useTranslation } from 'react-i18next';

const ContactInfoSection = () => {
  const { t, i18n } = useTranslation('common');
  const lng = (i18n.language || 'en').split('-')[0];
  const labels = {
    phone: { ar: 'الهاتف', ur: 'فون', en: 'PHONE', fr: 'TÉLÉPHONE', de: 'TELEFON', es: 'TELÉFONO', pt: 'TELEFONE', ja: '電話', hi: 'फोन', it: 'TELEFONO', ru: 'ТЕЛЕФОН', zh: '电话' },
    address: { ar: 'العنوان', ur: 'پتہ', en: 'ADDRESS', fr: 'ADRESSE', de: 'ADRESSE', es: 'DIRECCIÓN', pt: 'ENDEREÇO', ja: '住所', hi: 'पता', it: 'INDIRIZZO', ru: 'АДРЕС', zh: '地址' },
    email: { ar: 'البريد الإلكتروني', ur: 'ای میل', en: 'EMAIL', fr: 'E-MAIL', de: 'E-MAIL', es: 'CORREO', pt: 'E-MAIL', ja: 'メール', hi: 'ईमेल', it: 'E-MAIL', ru: 'ЭЛ. ПОЧТА', zh: '邮箱' }
  };
  const tv = (key, fallback) => i18n.getResource(lng, 'common', key) || fallback;
  const phoneLabel = tv('contact.info.phoneLabel', labels.phone[lng]);
  const addressLabel = tv('contact.info.addressLabel', labels.address[lng]);
  const emailLabel = tv('contact.info.emailLabel', labels.email[lng]);
  const contactItems = [
    { icon: 'phone', color: '#6c534e', label: phoneLabel, detail: t('contact.info.phoneValue') }, // Brown
    { icon: 'location', color: '#db9324', label: addressLabel, detail: t('contact.info.addressValue') }, // Yellow
    { icon: 'mail', color: '#0d0b0c', label: emailLabel, detail: t('contact.info.emailValue') } // Black
  ];

  return (
    <section className="relative bg-cream overflow-hidden">
      <div className="container mx-auto px-4 pt-8 pb-16 relative">
        <div
          className="absolute inset-x-0 top-0 -bottom-12 opacity-[0.55] pointer-events-none z-0"
          style={{
            backgroundImage: "url('/assets/imgs/Contact/Dot map BG.png')",
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          }}
        />
        <div className="relative z-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-1 mb-4 max-w-[1040px] mx-auto lg:justify-items-center">
          {contactItems.map((item, i) => (
            <div key={i} className="group relative z-10 flex flex-col items-center text-center max-w-fit transition-transform duration-300 hover:-translate-y-1">
              <div className="w-[100px] h-[100px] rounded-[14px] shadow-[0_4px_8px_rgba(0,0,0,0.15)] relative mb-1.5 flex-shrink-0 transition-all duration-300 group-hover:shadow-xl group-hover:scale-105" style={{ backgroundColor: item.color }}>
                {item.icon === 'phone' && (
                  <svg className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" width="34" height="34" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.86 19.86 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.86 19.86 0 0 1 2.09 4.18 2 2 0 0 1 4.06 2h3a2 2 0 0 1 2 1.72c.12.89.32 1.76.59 2.6a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.48-1.11a2 2 0 0 1 2.11-.45c.84.27 1.71.47 2.6.59A2 2 0 0 1 22 16.92z" fill="#ffffff"/>
                  </svg>
                )}
                {item.icon === 'location' && (
                  <svg className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" width="34" height="34" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C8.686 2 6 4.686 6 8c0 5.25 6 12 6 12s6-6.75 6-12c0-3.314-2.686-6-6-6zm0 8.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z" fill="#ffffff"/>
                  </svg>
                )}
                {item.icon === 'mail' && (
                  <svg className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" width="34" height="34" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm-1.4 4.25-6.2 4.65a1 1 0 0 1-1.2 0L5 8.25V7l7 5 7-5v1.25z" fill="#ffffff"/>
                  </svg>
                )}
              </div>
              <div className="mt-0">
                <div className="font-poppins font-semibold text-sm text-text-dark tracking-[0.06em] leading-tight transition-colors duration-300 group-hover:text-brown">{item.label}</div>
                <div className="font-poppins font-normal text-[13px] text-text-gray opacity-95 leading-tight">{item.detail}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="relative z-10 grid grid-cols-1 lg:grid-cols-[520px_480px] justify-center gap-6 max-w-[1040px] mx-auto px-10 items-center">
          <div className="group rounded-[20px] overflow-hidden h-[460px] w-full transition-transform duration-500 hover:scale-[1.02] hover:shadow-xl">
            <img src="/assets/imgs/Contact/Inner Pages_Picture_Contact_1.png" alt="Office" className="w-full h-full object-cover rounded-[20px] transition-transform duration-500 group-hover:scale-[1.04]" />
          </div>
          <div className="rounded-[20px] overflow-hidden h-[420px] w-full lg:-translate-x-[72px] md:-translate-x-9 sm:translate-x-0 z-[2] transition-transform duration-500 hover:scale-[1.02] hover:shadow-xl">
            <iframe
              className="w-full h-[420px] border-0 outline-none rounded-[20px]"
              title="Map - United States"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d8477531.995947072!2d-113.13381396953107!3d38.461091107745424!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54b3155a0aa0a5b5%3A0x3a54e9f3f0f!2sUnited%20States!5e0!3m2!1sen!2sus!4v1700000000000"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactInfoSection;
